var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('input',{staticClass:"button input-button",attrs:{"type":"button","value":_vm.$props.value,"name":_vm.$props.name},on:{"click":_vm.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }